import { Mods, mods, theme } from '@approvalmax/theme';
import { StyledMods } from '@styled-kit/mods';
import styled from 'styled-components';

import { Dropdown } from '../../../../components';
import { outsideElementsColumnWidthPx, stickyColumnZIndex } from '../../Table.constants';

export const RowActionMenuCell = styled.td<StyledMods<Mods<'bordered'>>>`
    width: ${outsideElementsColumnWidthPx}px;
    position: sticky;
    right: 0;
    background-color: ${theme.color.white100} !important;
    border: 1px solid transparent;
    z-index: ${stickyColumnZIndex + 2};

    &:before {
        content: '';
        display: block;
        position: absolute;
        border-top: 2px solid ${theme.color.white100};
        border-bottom: 2px solid ${theme.color.white100};
        border-right: 2px solid ${theme.color.white100};
        top: -1px;
        bottom: -1px;
        left: -1px;
        right: -1px;

        ${mods.bordered.true`
            border-left: 1px solid ${theme.color.midnight50};
        `}
    }
`;

export const RowActionMenuCellContent = styled(Dropdown)<StyledMods<Mods<'open'>>>`
    opacity: 0.001;

    ${mods.open.true`
        opacity: 1;
    `}
`;
